import { createFileRoute } from "@tanstack/react-router";

import Revenue from "../pages/Revenue";
import { RequireAuth } from "../utils/RequireAuth";

// App.jsx folded the admin check into ProtectedRoute's isAuthenticated, which
// sent authenticated non-admins to /login. RequireAuth require="admin" sends
// them to "/" instead — an intentional fix of that /login bounce.
export const Route = createFileRoute("/_shell/revenue")({
  component: RevenueRoute,
});

function RevenueRoute() {
  return (
    <RequireAuth require="admin">
      <Revenue />
    </RequireAuth>
  );
}
